import { render, staticRenderFns } from "./PutDetailBuild.vue?vue&type=template&id=2235926d&scoped=true&lang=pug&"
import script from "./PutDetailBuild.vue?vue&type=script&lang=js&"
export * from "./PutDetailBuild.vue?vue&type=script&lang=js&"
import style0 from "./PutDetailBuild.vue?vue&type=style&index=0&id=2235926d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2235926d",
  null
  
)

export default component.exports